import StoreModule from '@bildvitta/store-module'
import axios from 'axios'

const storeModule = new StoreModule({
  apiService: axios,
  idKey: 'uuid',
  adapter: 'pinia'
})

export default storeModule
